import api from "./index";

export interface EnrollmentOrdersListeners {
  courseId: string;
  hasProtocol?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  offset?: number;
  limit?: number;
  options?: any;
}
export default (params: EnrollmentOrdersListeners) => {
  return api.EnrollmentOrderApi.listeners(
    params.courseId,
    params.hasProtocol,
    params.createdAtMin,
    params.createdAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.offset,
    params.limit,
    params.options
  );
};
